export default __webpack_public_path__ + "static/97e246a8b6f227188c06aa7ba466268f.jpeg";